import React from "react";
import style from "./style";
import FakerProduts from "@/components/Fakes/products";
import FakerCommercialArea from "@/components/Fakes/commercial-area";

const FakeMyProducts = () => {
  return (
    <div className="container faker-my-products">
      <div className="products">
        <FakerProduts />
      </div>
      <div className="banners">
        <FakerCommercialArea />
      </div>

      <style jsx>{style}</style>
    </div>
  );
};

export default FakeMyProducts;
